export function checkPhotoFile(file) {
  const ext = file.name
    .split(".")
    [file.name.split(".").length - 1].toLowerCase();
  if (ext !== "jpg" && ext !== "jpeg" && ext !== "png") {
    throw new Error("Picture file must be a .jpg, .jpeg, or .png");
  } else if (file.size > 10000000) {
    throw new Error("Picture must be less than 10 megabytes");
  } else {
    return file;
  }
}
